<footer
  class="tracking-page-footer visual-builder-block no-border-spacing"
  [ngStyle]="{
    'background-color': trackingPage?.footer?.backgroundColor || '#fff'
  }"
  [class.selected]="selectedId?.id?.includes('footer')"
  (click)="selectItem.emit('footer')"
>
  <div
    class="container-fluid"
    [class.container]="!noSidebar"
    [class.container-min]="noSidebar"
  >
    <div
      class="pl-3 pr-3 tracking-page-footer__content"
      [class.justify-content-end]="trackingPage?.footer?.hideTrackmageBranding"
    >
      <div
        class="tracking-page-footer__powered-words"
        [ngStyle]="trackingPage?.footer | fontFamily: 'fontFamily'"
        *ngIf="!trackingPage?.footer?.hideTrackmageBranding"
      >
        <span [ngStyle]="trackingPage?.footer | fontFamily: 'color'">
          {{ 'powered_by' | translate }}
        </span>
        <a
          [style.text-decoration]="
            trackingPage?.footer?.linksUnderline ? 'underline' : 'none'
          "
          (click)="onAnchorClick($event)"
          [style.color]="trackingPage?.footer?.linksColor"
          href="https://trackmage.com/"
          target="_blank"
          >TrackMage.com</a
        >
      </div>
      <div>
        <ul class="tracking-page-footer__links">
          <li
            class="tracking-page-footer__links-link"
            *ngFor="let link of trackingPage?.footer?.links | reverse"
            [ngStyle]="trackingPage?.footer | fontFamily: 'fontFamily'"
          >
            <p
              [ngStyle]="trackingPage?.footer | fontFamily: 'color'"
              *ngIf="!link.url; else withLink"
            >
              {{ link.title }}
            </p>
            <ng-template #withLink>
              <a
                [style.color]="trackingPage?.footer?.linksColor"
                [style.text-decoration]="
                  trackingPage?.footer?.linksUnderline ? 'underline' : 'none'
                "
                (click)="onAnchorClick($event)"
                [attr.href]="link.url"
                target="_blank"
                >{{ link.title }}</a
              >
            </ng-template>
          </li>
        </ul>
      </div>
    </div>
  </div>
</footer>
<!-- /footer -->
